// extracted by mini-css-extract-plugin
module.exports = {"stop":"styles_stop__UCFVJ","disabled":"styles_disabled___mXke"};